module.exports = __webpack_public_path__ + "img/func2.0fbefc25.png";